import React, { useEffect, useRef, useState } from 'react'
import { GoStarFill } from "react-icons/go";
import { GoStar } from "react-icons/go";
import { Quotes } from '../assets/svg';
const StoriesCard = ({empName, story}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 400;

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

 
  return (
    <div className={`stories-card ${isExpanded ? 'auto-card' : ''}`} >
        <div className='rattings-header d-flex items-center justify-content-between'>
            <Quotes />
            <div className='rattings d-none gap-1'>
               <span><GoStarFill /></span> 
               <span><GoStarFill /></span> 
               <span><GoStarFill /></span> 
               <span><GoStarFill /></span> 
               <span><GoStar /></span> 

            </div>

        </div>
        <h3 className='mb-0'>What our people say...</h3>

        <p className='mb-0 life-at-volto-content'>{isExpanded ? story : `${story.slice(0, maxLength)} `}
        {story.length > maxLength && (
          <span className="read-more-less" onClick={toggleReadMore}>
            {isExpanded ? "...Read Less" : "...Read More"}
          </span>
        )}</p>

        <div className='stories_author_info d-flex align-items-center gap-4'>
            <img src="images/user-avatar.png" alt="stories-avtar" />
            <div>
                
                <p className='mt-0 mb-0'>{empName}</p>
            </div>
        </div>
       
    </div>
  )
}

export default StoriesCard
